// ** Redux
import { useSelector } from "react-redux";

// ** Custom Components
import Block from "components/layout/Block";
import ResultsDescription from "./components/ResultDescription";
import PostsFilters from "../PostsFilters/PostsFilters";

// #####################################################

export const PostsFiltersSection = () => {
	const filtersOpen = useSelector((state) => state.sharedFilters.isOpen);

	return (
		<Block flex column>
			<ResultsDescription />
			{filtersOpen && <PostsFilters />}
		</Block>
	);
};

// #####################################################
